import { T } from '@homeschooling/sdk'

import m from 'moment'
import * as React from 'react'
import * as _ from 'lodash'

import Persistance from "../Persistence";

import { BlankCalendar, Back, Caret } from '../../Components/Icons'
import  ScheduleTile from '../../Components/Schedule/ScheduleTile'
import HorizontalLine from '../Common/HorizonalLine';
import Focus from './Focus'

export interface Props {
    children?: React.ReactNode
    schedule: T.ScheduleDay
    showDate?: boolean
    className?: string
    updateNote: (note: T.Progress) => void
    updateExpense: (expense: T.Expense) => void
    updateSchedule: () => void
}
  
export interface State {
    students: T.Student[],
    focusEvent: T.Schedule | boolean,
    events: T.Schedule[],
}

Persistance.setValues()

export class ScheduleDay extends React.Component<Props, any> {

    public constructor (props: Props) {
        super(props)

        this.state = {
          students: Persistance.getStudents(),
          focusEvent: false,
          events: this.props.schedule.events,
          currentDay: this.props.schedule.date
        }
      }

    public showEvent = (e: T.Schedule | boolean) => {
        //console.log('setting event', e)
        this.setState({focusEvent: e})
    }

    public getStudentFromId = (id: string | number) => {

        return _.find(this.state.students, {id: Number(id)})

    }

    public getEmptyState = () => {
        return (
            <div className='w-full h-full flex flex-col gap-col-8 p-4 justify-items-center'>
                <div className='w-full grid'>
                    <BlankCalendar className='fill-slate-500 w-[50%] justify-self-center'/>
                </div>
                <div className='w-full text-center text-gray-800 font-semibold text-xl mt-8'>
                    Your day is free.
                </div>
                <div className='w-full text-center text-md text-gray-900 font-medium mt-4'>
                    Create a new scheduled event to keep track of activities and classes
                </div>
            </div>
        )
    }

  public makeEvents = () => {
    
    let events = this.props.schedule.events
    let display = []

    if (events.length === 0){
        return this.getEmptyState()
    }

    if (this.state.focusEvent && this.state.currentDay === this.props.schedule.date){

        let event = this.state.focusEvent

        //let student = this.getStudentFromId(event.student_id)
        let eventPos = events.indexOf(event)
        let prevEvent = events[eventPos - 1]
        let nextEvent = events[eventPos + 1]

        let rightCaret = (<div className='rotate-90 cursor-pointer' onClick={() => this.showEvent(nextEvent)}><Caret size='small' className='fill-slate-800'/></div>)
        let leftCaret = (<div className='-rotate-90 cursor-pointer' onClick={() => this.showEvent(prevEvent)}><Caret size='small' className='fill-slate-800'/></div>)

        if (eventPos === 0) {
            leftCaret = (<div className='-rotate-90'><Caret size='small' className='fill-slate-400'/></div>)
        }

        if (eventPos === events.length - 1) {
            rightCaret = (<div className='rotate-90'><Caret size='small' className='fill-slate-400'/></div>)
        }

        return (<div className='focused_event w-full h-full flex flex-col'>
            <div className='w-full flex grow flex-col'>
                <div className='w-full flex flex-col grow'>
                    
                    <div className='w-full flex h-6 items-center border-b-2 py-4 px-2'>
                            <div className='flex grow'>
                                <div className='w-4 cursor-pointer' onClick={() => this.showEvent(false)}>
                                    <Back 
                                        className='fill-black'
                                        size='medium' />
                                </div>
                            </div>
                        <div className='flex flex-none flex-row-reverse items-center'>
                            <div className='flex-none'>
                               {rightCaret} 
                            </div>
                            <div className='flex grow self-center'>{this.makeEventDots(eventPos)}</div>
                            <div className='flex-none'>
                                {leftCaret}    
                            </div>
                        </div>    
                    </div>

                    <div className='w-full'>
                        <Focus
                            event={event}
                            currentDay={this.state.currentDay}
                            updateNote={(note: T.Progress) => this.props.updateNote(note)}
                            updateExpense={(expense: T.Expense) => this.props.updateExpense(expense)}
                            updateSchedule={() => this.updateSchedule(false)}
                            />
                    </div>
                    
                </div>    
            </div>
        </div>)
    }

    if(this.state.currentDay !== this.props.schedule.date ){
        this.setState({currentDay: this.props.schedule.date, focusEvent: false})
    }

    for (let e of events){

        let student = {} as T.Student
        let pos = events.indexOf(e)
        let length = events.length

        display.push(
        <div id={`event-${this.props.schedule.date}-${e.id}`} className='w-full flex flex-col'>
            <div  className='w-full flex-col flex text-xs p-1 hover:bg-accent-200 hover:cursor-pointer' onClick={() => this.showEvent(e)}>
            {<ScheduleTile
                student = {student}
                event = {e} 
                date={this.props.schedule.date}
                />}
            </div>
        </div>   
        )

        if( pos < ( length - 1 )) {
            display.push(
                <HorizontalLine
                color='#999999' 
                size='1px'
                padding='3.5em'/>
            )
        }
    }

    return display

  }  
  
  public updateSchedule = (showFocus: boolean = false) => {
    if(!showFocus){
        this.showEvent(false)
    }
    this.props.updateSchedule()
  }

  public makeEventDots = (eventPos: number) => {

    let dots = []
    
    let count = this.props.schedule.events.length
    let i = 0

    while( i < count ) {
        if(i === eventPos){
          dots.push(<div className='h-2 w-2 bg-primary-900 rounded-full border border-zinc-300 mx-0.5'></div>)   
        } else {
          dots.push(<div className='h-1 w-1 rounded-full bg-secondary-300 border-zinc-300 mx-0.5'></div>)  
        }   
        
        i++
    }

    return(<div className='w-full h-3 flex flex-columns items-center justify-center'>
        {dots}
    </div>)
  }

  public getDateLine = () => {

    const day = this.props.schedule

    if (this.props.showDate){
        return(
            <div className='w-full text-primary-900 text-center flex-none text-gray-600 font-semibold uppercase text-s border-zinc-300 border-b-2 py-2'>
                <span className='font-light lowercase'>{m(day.date).format('ddd')}</span> {m(day.date).format('MMM DD')} <span className='font-light lowercase'>{m(day.date).format('YYYY')}</span>
            </div> 
        )
    }

    return(<div></div>)

  }

  public render(): React.ReactNode {
    const day = this.props.schedule

    return (
        <div id={`schedule-dash-${day.date}`} className="flex flex-col justify-left grow border-2 border-zinc-300">  
            {this.getDateLine()}
        <div className='w-full h-full overflow-hidden'>
            {this.makeEvents()}
        </div>
    </div>
    )
  }  
  
}

export default  ScheduleDay